import { useMutation } from '@tanstack/react-query';

export function useCreateProjectReportExportProcessMutation() {
  return useMutation({
    mutationFn: async ({ exportParams }) => {
      const response = await axios.post('/project_reports/export_processes', {
        project_report: exportParams,
      });

      return response.data;
    },
  });
}
